import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css';
import fr from 'vuetify/es5/locale/fr';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: { customProperties: true },
    themes: {
      light: {
        main: '#c71900',
        primary: '#f44336',
        secondary: '#f5f5f5',
        accent: '#f7557b',
        success: '#4CAF50',
        lightBlue: '#64B5F6',
        lightGreen: '#1de9b6',
        lightGray: '#cfd8dc',

        black: '#000000',
        onBlack: '#FFFFFF',

        surfaceMuted: '#F7F7F8',
        surfaceMutedAlt: '#E9EAEC',
        textMuted: '#6B7280',

        green: '#DCFCE7',
        onGreenOutline: '#7bf1a8',
        onGreen: '#016630',

        violet: '#F3E8FF',
        violetVariant: '#512da8',
        onVioletOutline: '#7E22CE',
        onViolet: '#7E22CE',
        onVioletVariant: '#FFFFFF',

        blue: '#DBEAFE',
        onBlueOutline: '#1D4ED8',
        onBlue: '#1D4ED8',

        red: '#FEE2E2',
        onRedOutline: '#B91C1C',
        onRed: '#B91C1C',

        yellow: '#FEF3C7',
        yellowVariant: '#EAB308',
        onYellow: '#B45309',
        onYellowOutline: '#B45309',

        orange: '#FED7AA',
        orangeVariant: '#F97316',
        onOrange: '#9A3412',
        onOrangeOutline: '#9A3412'
      }
    }
  },
  lang: {
    locales: { fr },
    current: 'fr'
  }
});
